module.exports = __webpack_public_path__ + "static/media/wardah.b4c81e30.jpg";